module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Le sauveteur")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("Par Rhys Ford")]), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("Série 415 Ink, tome 2")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dans tout homme bon, il y a un sauveteur, mais parfois, c’est l’amour qui réveille l’homme dans le sauveteur.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Mace Crawford, sapeur-pompier de San Francisco, a connu une enfance difficile. Enlevé par nécessité à son épouvantable père, il a été élevé dans le système fédéral, froid et indifférent. Devenu adulte, il consacre sa vie à sauver les autres, y compris les frères qu’il s’est choisis. Second de sa brigade, Mace guide ceux qui sont sous ses ordres ; à 415 Ink, le salon de tatouage familial, il apporte son aide, mais par-dessus tout, il protège sa famille de son secret le plus sombre.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Alors qu’il s’est juré de ne jamais aimer, un gros problème apparaît dans sa vie solitaire : Rob Claussen, un des tatoueurs de 415 Ink, l’obsède de plus en plus.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Mace a édifié de strictes frontières pour protéger son univers contrôlé – et son cœur, mieux barricadé encore. Il ne peut y faire entrer Rob, il ne peut céder à son désir sans risquer d’abattre les fondations mêmes de l’existence qu’il s’est bâtie.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Un jour pourtant, un démon du passé refait surface et Mace est alors confronté à un choix : s’accrocher à ses mensonges ou sauver celui qu’il a si peur d’aimer.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0